import { render, staticRenderFns } from "./Analyses.vue?vue&type=template&id=226f4990&scoped=true"
import script from "./Analyses.vue?vue&type=script&lang=js"
export * from "./Analyses.vue?vue&type=script&lang=js"
import style0 from "./Analyses.vue?vue&type=style&index=0&id=226f4990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f4990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
